<div class="container-fluid webView" style="padding-left: 20px; padding-right: 15px;">
    <div class="row">
        <div class="col-md-12 col-12 col-sm-12 padHeader" style="padding-bottom: 15px;">
            GSPC
        </div>
    </div>
</div>
  

  
<div class="container-fluid bg mobView" style="min-height: 100vh; box-sizing: border-box;">
    <div style="background-color: #f1f1f0; min-height: calc(100vh - 20px); box-sizing: border-box;">
        <!-- Header -->
        <div class="padHeader">
            <!-- Title and Back Btn -->
            <div class="mb-10" style="display: flex; justify-content: space-between;">
                <div class="col-md-6 col-6 col-sm-6 pad0">
                 <img src="/ERP/assets/images/gspc-logo.png" style="height: 30px;">
                </div>
                <div class="btn darkBlueButton" style="align-self: center;" (click)="backToHomeBtn()">
                    <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>
                    Back
                </div>
            </div>
            <!-- Basic Info -->
            <div style="display: flex; flex-wrap: wrap;">
                <div *ngIf="address != ''" class="width100" style="color: grey; font-size: 14px;">
                    <span>{{address}}</span>
                </div>
                <div *ngIf="userName != ''" class="width100" style="color: grey; font-size: 14px;">
                    <span>Logged in as: {{userName}}</span>
                </div>
            </div>
        </div>
        <!-- Body -->
        <div class="padHeader mb-10" style="display: flex; flex-wrap: wrap; justify-content: space-between;">
            <div class="width100 mb-10" style="font-size: 28px; font-weight: 700; margin-bottom: 25px;">
                Meter Reading Entry
            </div>

            <div class="inLneBlk width100 mb-10" style="color: #2b7fb3; margin-bottom: 20px;">
                <div class="label-new" style="color: #333; font-size: 16px;">
                    Meter Reading <span class="redText">*</span>
                </div>
                <span class="currency-input" style="font-weight: bold; color: #333; font-size: 17px;">
                    <input type="number" class="form-control formCtlFltr brdrRadius3" [(ngModel)]="meterRdng" (focus)="onFocusEvent($event)" style="width: 50%; text-align: right; margin-right: 5px;">
                    <span class="currency-symbol" style="color: grey; font-weight: normal; padding-left: 8px; font-size: 15px; color: black; font-weight: bold;">kg</span>
                </span>
            </div>

            <div class="inLneBlk width100 mb-10" style="color: #2b7fb3;">
                <div class="label-new" style="color: #333; font-size: 16px;">
                    Confirm Meter Reading <span class="redText">*</span>
                </div>
                <span class="currency-input" style="font-weight: bold; color: #333; font-size: 17px;">
                    <input type="number" class="form-control formCtlFltr brdrRadius3" [(ngModel)]="confirmMeterRdng" (focus)="onFocusEvent($event)" style="width: 100%; text-align: right; margin-right: 5px;">
                    <span class="currency-symbol" style="color: grey; font-weight: normal; padding-left: 8px; font-size: 15px; color: black; font-weight: bold;">kg</span>
                </span>
            </div>

            <span style="font-size: 12px;"
                [ngStyle]="{
                    'display': errTxtVisible ? 'inline' : 'none',
                    'color': errTxtType === 'success' ? 'darkGreen' : 'red'}">
                {{errTxt}}
            </span>

            <div class="width100 mb-10" style="display: flex; gap: 10px; font-size: 16px; margin-top: 15px; flex-wrap: wrap;">
                <span class="btn-darkGreen ng-scope brdrRadius3" style="padding: 2px 7px; width: 100%; line-height: 35px;" (click)="saveMeterRdng()">
                    <i class="fa fa-check" style="margin-right: 5px;"></i>
                    <span>Save Entry</span>
                </span>
                <span class="lable-BtnDarkBLue brdrRadius3" style="padding: 3px 7px; width: 100%; display: none;" (click)="backToHomeBtn()">
                    <i class="fa fa-close" style="margin-right: 3px;"></i>
                    <span>Close</span>
                </span>
            </div>
        </div>
    </div>
</div>
